module.exports = __webpack_public_path__ + "assets/img/num-01-2e97e123.png";